<template>
  <Page title="Formularz weryfikacji wydarzeń">
    <component :is="loadedForm"></component>
  </Page>
</template>

<script>
// import Certification from "@/components/Certification/";
import "@/components/Certification/";
import Page from "@/components/Elements/Page";
import ViewMixin from "@/mixins/View";

export default {
  name: "CertificationView",
  components: {
    // Certification,
    Page
  },
  mixins: [ViewMixin],
  data() {
    return {
      loadedForm: "CertificationForm191001"
    };
  },
  mounted() {
    let formId = this.$route.params.id || null;
    this.$store
      .dispatch("Event/whichForm", formId)
      .then(res => (this.loadedForm = `CertificationForm${res}`));
  }
};
</script>

<style class="scss"></style>
